import axiosClient from '../../configs/axios.js';


class Dailydistributionrepot {
    // Get list 
    async getdailydistributionrepotlist(params) {
        try {
            const response = await axiosClient.get(
                `/reports/DailyDistribution?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }





 








   
    
}

export default new Dailydistributionrepot(); 